import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui';

export default function NotFound() {
	return (
		<div className="min-h-screen grid place-items-center p-8 bg-ground">
			<div className="text-center max-w-md">
				<p className="text-sm font-semibold text-brand-700 uppercase tracking-wider">
					404
				</p>
				<h1 className="mt-2 text-3xl font-semibold text-ink">Page not found</h1>
				<p className="mt-3 text-ink-muted">
					The page you’re looking for either moved or never existed.
				</p>
				<div className="mt-6">
					<Link to="/">
						<Button>Back to home</Button>
					</Link>
				</div>
			</div>
		</div>
	);
}
